import React from "react";
import { toStringMessageDate } from "../vendor/DateUtil";

export const Content = () => {
  const date = new Date();
  toStringMessageDate(date);
  const content = "Some Text here hello";
  return <div>{content}</div>;
};
